import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import './App.css';
import GlobalStyles from './styles/GlobalStyles';
import { AuthProvider } from './contexts/AuthContext';
import Layout from './components/Layout/Layout';
import ChatAssistant from './components/ChatAssistant/ChatAssistant';
import ChatCrisis from './components/Crisis/ChatCrisis';
import ChatPage from './components/ChatAssistant/ChatPage';

// Auth
import Login from './components/Auth/Login';
import Register from './components/Auth/Register';
import ProtectedRoute from './components/Auth/ProtectedRoute';

// Home
import CommandCenter from './components/Home/CommandCenter';
import Copiloto from './components/Copiloto/Copiloto';
import Agente from './components/Agente/Agente';
import Agenda from './components/Agenda/Agenda';

// Political Profile Components
import PoliticalProfile from './components/PoliticalProfile/PoliticalProfile';
import ReputacionHub from './components/Reputacion/ReputacionHub';
import PoliticalDiscourse from './components/Discourse/PoliticalDiscourse';
import CompetitorsAnalysis from './components/Competitors/CompetitorsAnalysis';
import MediaPresence from './components/Media/MediaPresence';
import SocialPresence from './components/Social/SocialPresence';
import SocialProfileDetail from './components/Social/SocialProfileDetail';
import DigitalProfilesList from './components/DigitalProfiles/DigitalProfilesList';
import DigitalProfileDetail from './components/DigitalProfiles/DigitalProfileDetail';
import CreadorPerfiles from './components/DigitalProfiles/CreadorPerfiles';
import AutomationDashboard from './components/Automation/AutomationDashboard';
import CampaignObjectives from './components/Objectives/CampaignObjectives';
import Planning from './components/Planning/Planning';

import OpportunitiesRisks from './components/OpportunitiesRisks/OpportunitiesRisks';
import OKRs from './components/OKRs/OKRs';
import Messaging from './components/Messaging/Messaging';
import MediaMonitoring from './components/MediaMonitoring/MediaMonitoring';
import KPIs from './components/KPIs/KPIs';
import Configuration from './components/Configuration/Configuration';
import Research from './components/Research/Research';
import ResearchDetail from './components/Research/ResearchDetail';
import HCDMonitoring from './components/HCDMonitoring/HCDMonitoring';
import AuthorityProfile from './components/HCDMonitoring/AuthorityProfile';
import InvestigationList from './components/Investigation/InvestigationList';
import InvestigationDetail from './components/Investigation/InvestigationDetail';
import PoliticianProfilePage from './components/Investigation/PoliticianProfilePage';
import AnalysisList from './components/Analysis/AnalysisList';
import AnalysisDetail from './components/Analysis/AnalysisDetail';
import AiLive from './components/AiLive/AiLive';
import Territorio from './components/Territorio/Territorio';
import Camino2027 from './components/Camino2027/Camino2027';
import Prensa from './components/Prensa/Prensa';
import Vecinos from './components/Vecinos/Vecinos';
import Labor from './components/Labor/Labor';
import Estrategia from './components/Estrategia/Estrategia';
import EnAccion from './components/Public/EnAccion';
import Propuesta from './components/Public/Propuesta';
import Electoral from './components/Electoral/Electoral';
import Licitaciones from './components/Licitaciones/Licitaciones';
import Urgencia from './components/Urgencia/Urgencia';
import ModoCrisis from './components/Crisis/ModoCrisis';
import SalaDeSituacion from './components/Crisis/SalaDeSituacion';
import Equipos from './components/Equipos/Equipos';

function App() {
  return (
    <Router>
      <GlobalStyles />
      <AuthProvider>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/register" element={<Register />} />
          <Route path="/en-accion" element={<EnAccion />} />
          {/* Propuesta comercial de Adbize — pública a propósito, para poder
              mandar el link sin que el destinatario tenga que loguearse. */}
          <Route path="/propuesta" element={<Propuesta />} />

          <Route
            path="/chat"
            element={
              <ProtectedRoute>
                <ChatPage />
              </ProtectedRoute>
            }
          />

          <Route
            path="/"
            element={
              <ProtectedRoute>
                <>
                  <ChatAssistant />
                  <ChatCrisis />
                  <Layout />
                </>
              </ProtectedRoute>
            }
          >
            {/* Home: Centro de mando */}
            <Route index element={<CommandCenter />} />
            <Route path="copiloto" element={<Copiloto />} />
            <Route path="agente" element={<Agente />} />
            <Route path="agenda" element={<Agenda />} />
            <Route path="perfil" element={<PoliticalProfile />} />
            <Route path="equipos" element={<Equipos />} />
            <Route path="ai-live" element={<AiLive />} />
            <Route path="dashboard" element={<Navigate to="/reputacion" replace />} />
            <Route path="discourse" element={<PoliticalDiscourse />} />
            <Route path="competitors" element={<CompetitorsAnalysis />} />
            <Route path="media" element={<MediaPresence />} />
            <Route path="social" element={<SocialPresence />} />
            <Route path="social/:id" element={<SocialProfileDetail />} />
            <Route path="perfiles-digitales" element={<DigitalProfilesList />} />
            <Route path="perfiles-digitales/:id" element={<DigitalProfileDetail />} />
            <Route path="creador-perfiles" element={<CreadorPerfiles />} />
            <Route path="automatizacion-perfiles-ia" element={<AutomationDashboard />} />
            <Route path="objectives" element={<CampaignObjectives />} />
            <Route path="planning" element={<Planning />} />
            <Route path="territorio" element={<Territorio />} />
            <Route path="camino-2027" element={<Camino2027 />} />
            <Route path="prensa" element={<Prensa />} />
            <Route path="vecinos" element={<Vecinos />} />
            <Route path="labor-hcd" element={<Labor />} />
            <Route path="estrategia" element={<Estrategia />} />
            <Route path="reputacion" element={<ReputacionHub />} />
            <Route path="electoral" element={<Electoral />} />
            <Route path="licitaciones" element={<Licitaciones />} />
            <Route path="urgencia" element={<Urgencia />} />
            <Route path="crisis" element={<ModoCrisis />} />
            <Route path="crisis/:id" element={<SalaDeSituacion />} />
            <Route path="briefing-passaglia" element={<Navigate to="/urgencia" replace />} />

            {/* Legacy Routes (kept for reference) */}
            <Route path="opportunities" element={<OpportunitiesRisks />} />
            <Route path="okrs" element={<OKRs />} />
            <Route path="messaging" element={<Messaging />} />
            <Route path="media-monitoring" element={<MediaMonitoring />} />
            <Route path="monitoring/hcd" element={<HCDMonitoring />} />
            <Route path="monitoring/hcd/autoridad/:slug" element={<AuthorityProfile />} />
            <Route path="investigations" element={<InvestigationList />} />
            <Route path="investigations/politico/:slug" element={<PoliticianProfilePage />} />
            <Route path="investigations/:slug" element={<InvestigationDetail />} />
            <Route path="analysis" element={<AnalysisList />} />
            <Route path="analysis/:slug" element={<AnalysisDetail />} />
            <Route path="research" element={<Research />} />
            <Route path="research/:id" element={<ResearchDetail />} />
            <Route path="kpis" element={<KPIs />} />
            <Route path="settings" element={<Configuration />} />
            <Route path="security" element={<Configuration />} />
          </Route>
        </Routes>
      </AuthProvider>
    </Router>
  );
}

export default App;
